const formatDataForFilters = (type, data) => {
  switch (type) {
    case "inbound":
      return data?.map((x) => ({
        id: x?.id,
        createdAt: x?.createdAt,
        studentName: x?.offerSlot?.student?.fullName || "N/A",
        subjectInfo: x?.offerSlot?.offer?.offerSubjects,
        status: x?.offerSlot?.status,
        amount: x?.amount,
        currency: x?.currency,
        channel: x?.channel,
        offerSlotId: x?.offerSlotId,
        offerId: x?.offerSlot?.offer?.id,
        teacherId: x?.teacherId,
        transfered: x?.offerSlot?.paymentStatusTeacher ? true : false,
      }));
    case "outbound":
      return data?.map((x) => ({
        id: x?.id,
        date: x?.createdAt,
        amount: x?.amount,
        currency: x?.currency,
        status: "PAID",
        teacherId: x?.teacherId,
        receiptUrl: x?.receiptUrl,
      }));
    case "merge":
      return data?.map((x) => ({
        id: x?.id,
        date: x?.createdAt,
        amount: x?.amount,
        currency: x?.currency,
        channel: x?.channel,
        student: x?.offerSlot?.student?.fullName,
        subjects: x?.offerSlot?.offer?.offerSubjects,
        sessionStatus: x?.offerSlot?.status,
        offerSlotId: x?.offerSlotId,
        offerId: x?.offerSlot?.offer?.id || "",
        status: x?.transactionDetails?.TransactionStatus,
        teacherId: x?.teacherId,
      }));
    default:
      return data;
  }
};

export default formatDataForFilters;
